(() => {
  function init() {
    document.querySelectorAll('[data-kit-help]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const toggle = root.querySelector('.kit-help-toggle');
      const panel = root.querySelector('.kit-help-panel');
      const answer = root.querySelector('.kit-help-answer');
      const questions = [...root.querySelectorAll('[data-answer]')];
      const setOpen = open => { panel.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); if (open) root.querySelector('[data-help-close]').focus(); else toggle.focus(); };
      toggle.addEventListener('click', () => setOpen(panel.hidden));
      root.querySelector('[data-help-close]').addEventListener('click', () => setOpen(false));
      root.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
      const reply = text => { answer.textContent = text; answer.hidden = false; };
      questions.forEach(button => button.addEventListener('click', () => reply(button.dataset.answer)));
      root.querySelector('form').addEventListener('submit', e => {
        e.preventDefault();
        const value = root.querySelector('input').value.trim();
        if (!value) { root.querySelector('input').focus(); return; }
        const q = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const rules = [/inclu|campan|diseno|pagina|formato|story|stories|post|contenido/,/descarg|recib|entrega|correo|acceso|pdf/,/canva|editar|edito|personaliz|logo|colores|pro\b|gratis/,/precio|cuanto|pago|cost|envio/,/devol|reembols|cancel|fall|problema|enlace/];
        const index = rules.findIndex(rule => rule.test(q));
        reply(index < 0 ? 'No tengo una respuesta preparada para esa consulta. Escríbenos a clovers.92@gmx.com y te ayudaremos. No introduzcas datos de pago en este asistente.' : questions[index].dataset.answer);
      });
    });
    document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
        else { const notice = document.querySelector('[data-cookie-notice]'); if (notice) notice.hidden = false; }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
